export default "__VITE_ASSET__CXkYVC$W__"